<div class="app-page-title">
    <div class="page-title-wrapper">
        <div class="page-title-heading">
            <div class="page-title-icon">
                <i class="pe-7s-diamond icon-gradient bg-mean-fruit">
                </i>
            </div>
            <div>Compte business
                <div class="page-title-subheading">Ajouter compte business.
                </div>
            </div>
        </div>
    </div>
</div>
<div class="tab-content">
    <div class="row">
        <div class="col-12">
            <div class="main-card mb-12 card">
                <div class="card-body">
                    <form class="" action="" method="post" onsubmit="return false;">
                        <div class="row form-group">
                            <div class="col-12">
                                <div class="form-group">
                                    <legend for="socities" class="">Société</legend>
                                    <select name="socities" id="socities" class="form-control"
                                        [(ngModel)]="selectedSociety">
                                        <option [ngValue]="null">
                                            Selectionnez la société
                                        </option>
                                        <option *ngFor="let society of allSocties" [ngValue]="society._id"
                                            ngDefaultControl>{{society?.nom_user}}
                                        </option>
                                    </select>
                                    <mat-error style="color: red;font-weight: bold;" *ngIf="selectedSociety==null || selectedSociety=='null'">
                                        Cette question est obligatoire.
                                    </mat-error>
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <button type="submit" (click)="addBusinessAccount()"
                                class="btn btn-primary btn-lg btn-block">
                                Ajouter compte business
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>